// WhatsApp rejects a URL-button's `url` (#100 "not a valid URI") when it is
// just a bare "{{1}}" variable. The variable must be a suffix of a real,
// absolute URL (e.g. "https://example.com/{{1}}").
export const getUrlButtonError = (url) => {
  if (!url || !url.includes('{{'))
    return ''
  const prefix = url.split('{{')[0]
  if (!/^https?:\/\/[^\s{}]+$/i.test(prefix))
    return 'A URL deve começar com um domínio válido antes da variável, ex: https://seudominio.com/{{1}}'
  return ''
}
